import React from 'react';

import api    from '../../../api';
import values from '../../../values';

import { useQuery             } from 'react-query';
import { locationNamespace    } from '../../../types/location.namespace';
import { CustomDropdownSearch } from '../../index';

import './index.sass';

type Props = {
  isError         ?: boolean;
  errorText       ?: string;
  defaultItem      : locationNamespace.area.index | undefined;
  onSelectItem     : (province: locationNamespace.area.index) => void;
  selectedProvince?: locationNamespace.province.index;
  selectedCity    ?: locationNamespace.city.index;
}

const AreaDropdown: React.FC<Props> = (props: Props): React.ReactElement => {

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getArea = useQuery(
    [
      values.useQueryKeys.locationGetArea,
      props.selectedProvince?._id,
      props.selectedCity?._id,
    ],
    () => api.get.common.searchArea({
      limit: 50,
      city: props.selectedCity?._id,
      province: props.selectedProvince?._id,
    })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id='location-dropdown-search-city'>
      <span>انتخاب منطقه</span>
      <CustomDropdownSearch
        isSearch
        items={getArea?.data?.result?.docs || []}
        itemName={'name'} placeHolder={'انتخاب منطقه'}
        defaultItem={props.defaultItem}
        onSelectItem={props.onSelectItem}
      />
      {props?.isError && (<p>{props?.errorText}</p>)}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default AreaDropdown;
